module.exports = __webpack_public_path__ + "static/media/1350_Cart_GiftShop_purchaseHL.be02ea54.png";